export function buildWebsiteSchema({ siteUrl, siteName, locale = 'fr' }) {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: siteName,
    url: siteUrl,
    description:
      locale === 'en'
        ? 'WebRTC business video infrastructure for enterprises: integrable platform for professional journeys, video API, France hosting, and custom integration.'
        : 'Infrastructures vidéo métier WebRTC pour entreprises : socle intégrable aux parcours professionnels, API vidéo, hébergement France et intégration sur mesure.',
    publisher: {
      '@type': 'Organization',
      name: siteName,
      logo: {
        '@type': 'ImageObject',
        url: `${siteUrl}/logo.png`,
      },
    },
    inLanguage: locale === 'en' ? 'en-US' : 'fr-FR',
  };
}
